/* ============================================================
   Boneca de Pano — enhancement da galeria da PDP.
   Ao trocar a cor no variant picker, prioriza (setActiveMedia)
   a primeira mídia cujo alt/URL contenha o nome da cor —
   heurística por keywords/aliases portada de
   src/lib/product-images.ts do site React.

   Só age quando a variante NÃO tem featured_media própria
   (nesse caso o Dawn já foca a imagem da variante sozinho).
   ============================================================ */
(function () {
  'use strict';

  var COLOR_OPTION_NAMES = ['cor', 'color', 'cores'];

  var COLOR_ALIASES = {
    bege: ['bege', 'nude', 'areia', 'off', 'creme'],
    verde: ['verde', 'menta', 'militar', 'oliva'],
    rosa: ['rosa', 'pink', 'fucsia'],
    vermelho: ['vermelho', 'red', 'bordo', 'vinho'],
    terracota: ['terracota', 'telha', 'ferrugem', 'vermelho', 'coral'],
    roxo: ['roxo', 'lilas', 'violeta', 'purple'],
    azul: ['azul', 'blue', 'marinho'],
    marinho: ['marinho', 'navy', 'azul'],
    branco: ['branco', 'white', 'off'],
    preto: ['preto', 'black'],
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function getColorKeywords(color) {
    var normalized = normalize(color);
    var directParts = normalized.split(/[^a-z0-9]+/).filter(Boolean);
    var aliasMatches = [];
    Object.keys(COLOR_ALIASES).forEach(function (key) {
      if (normalized.indexOf(key) !== -1) {
        aliasMatches = aliasMatches.concat(COLOR_ALIASES[key]);
      }
    });
    var all = [normalized].concat(directParts, aliasMatches);
    return all.filter(function (kw, idx) {
      return kw && all.indexOf(kw) === idx;
    });
  }

  function mediaMatchesColor(li, keywords) {
    var img = li.querySelector('img');
    if (!img) return false;
    var haystack = normalize((img.alt || '') + ' ' + (img.currentSrc || img.src || ''));
    return keywords.some(function (keyword) {
      return keyword && haystack.indexOf(keyword) !== -1;
    });
  }

  function selectedColorValue(productInfo) {
    var inputs = productInfo.querySelectorAll('input[type="radio"]:checked[data-option-name]');
    for (var i = 0; i < inputs.length; i++) {
      if (COLOR_OPTION_NAMES.indexOf(normalize(inputs[i].dataset.optionName)) !== -1) {
        return inputs[i].value;
      }
    }
    return null;
  }

  function currentVariantJson(productInfo) {
    var script = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function activateColorMedia(productInfo, variant) {
    // Dawn já foca a mídia da variante quando ela tem featured_media própria.
    if (variant && variant.featured_media) return;

    var colorValue = selectedColorValue(productInfo);
    if (!colorValue) return;

    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    var keywords = getColorKeywords(colorValue);
    var items = gallery.querySelectorAll('.product__media-list li[data-media-id]');
    for (var i = 0; i < items.length; i++) {
      if (mediaMatchesColor(items[i], keywords)) {
        gallery.setActiveMedia(items[i].dataset.mediaId, true);
        return;
      }
    }
  }

  function handleVariantChange(productInfo, variant) {
    // Deixa o update de mídia do Dawn assentar antes de aplicar a heurística.
    setTimeout(function () {
      activateColorMedia(productInfo, variant);
    }, 50);
  }

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = (event && event.data) || {};
      if (!data.sectionId) return;
      var productInfo = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
      if (!productInfo) return;
      handleVariantChange(productInfo, data.variant || null);
    });
  } else {
    // Fallback sem pubsub: escuta a troca dos radios de cor e espera o
    // re-render do Dawn terminar antes de aplicar.
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.dataset || !input.dataset.optionName) return;
      if (COLOR_OPTION_NAMES.indexOf(normalize(input.dataset.optionName)) === -1) return;
      var productInfo = input.closest('product-info');
      if (!productInfo) return;
      setTimeout(function () {
        activateColorMedia(productInfo, currentVariantJson(productInfo));
      }, 700);
    });
  }
})();
